import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const BrandComponent = () => {
  const [brands, setBrands] = useState([
    {
      id: 1,
      name: "Lays",
      category: "Grocery/Health",
      subCategory: "Snack Foods",
      status: "Deactive",
    },
    {
      id: 2,
      name: "Ashirwaad",
      category: "Grocery/Health",
      subCategory: "All Grocery & Others",
      status: "Deactive",
    },
    {
      id: 3,
      name: "Coca Cola",
      category: "Grocery/Health",
      subCategory: "Beverages",
      status: "Deactive",
    },
    {
      id: 4,
      name: "Nescafe Gold",
      category: "Grocery/Health",
      subCategory: "Coffee & Tea",
      status: "Deactive",
    },
    {
      id: 5,
      name: "PriyaGold",
      category: "Grocery/Health",
      subCategory: "Snack Foods",
      status: "Deactive",
    },
  ]);

  const [brandName, setBrandName] = useState("");
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [descriptiveCategory, setDescriptiveCategory] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [currentBrand, setCurrentBrand] = useState(null);

  // Handle input changes
  const handleInputChange = (setter) => (e) => setter(e.target.value);

  // Handle create or update brand
  const handleCreateBrand = () => {
    if (brandName.trim() && category && subCategory) {
      const newBrand = {
        id: brands.length + 1,
        name: brandName,
        category,
        subCategory,
        status: "Deactive",
      };
      setBrands([...brands, newBrand]);
      resetForm();
    }
  };

  const handleUpdateBrand = () => {
    const updatedBrand = {
      ...currentBrand,
      name: brandName,
      category,
      subCategory,
    };
    setBrands(
      brands.map((brand) =>
        brand.id === currentBrand.id ? updatedBrand : brand
      )
    );
    resetForm();
  };

  // Handle delete brand
  const handleDeleteBrand = (id) => {
    setBrands(brands.filter((brand) => brand.id !== id));
  };

  // Set form for editing
  const handleEditBrand = (brand) => {
    setBrandName(brand.name);
    setCategory(brand.category);
    setSubCategory(brand.subCategory);
    setCurrentBrand(brand);
    setIsEditing(true);
  };

  // Reset form state
  const resetForm = () => {
    setBrandName("");
    setCategory("");
    setSubCategory("");
    setDescriptiveCategory("");
    setIsEditing(false);
    setCurrentBrand(null);
  };

  return (
    <div className="container mt-4">
      <div className="row mb-4">
        <div className="col-12">
          {/* Smaller Heading */}
          <h1 className="text-center mb-4 text-primary fs-5">
            {isEditing ? "Edit Brand" : "Create Brand"}
          </h1>

          {/* Brand Form */}
          <div className="card p-4 shadow-sm rounded-3">
            <div className="mb-3">
              <label className="form-label">Category Name</label>
              <select
                value={category}
                onChange={handleInputChange(setCategory)}
                className="form-select"
              >
                <option value="">Select Category</option>
                <option value="Grocery/Health">Grocery/Health</option>
                <option value="Home Appliances">Home Appliances</option>
                <option value="Electronics">Electronics</option>
                <option value="PersonalCare">PersonalCare</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Sub Category Name</label>
              <select
                value={subCategory}
                onChange={handleInputChange(setSubCategory)}
                className="form-select"
              >
                <option value="">Select SubCategory</option>
                <option value="Snack Foods">Snack Foods</option>
                <option value="All Grocery & Others">
                  All Grocery & Others
                </option>
                <option value="Beverages">Beverages</option>
                <option value="Coffee & Tea">Coffee & Tea</option>
                <option value="Mobile">Mobile</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Descriptive Sub Category Name
              </label>
              <input
                type="text"
                value={descriptiveCategory}
                onChange={handleInputChange(setDescriptiveCategory)}
                placeholder="Enter Descriptive SubCategory Name"
                className="form-control"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Brand Name</label>
              <input
                type="text"
                value={brandName}
                onChange={handleInputChange(setBrandName)}
                placeholder="Enter Brand Name"
                className="form-control"
              />
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button
                onClick={isEditing ? handleUpdateBrand : handleCreateBrand}
                className="btn btn-success"
              >
                {isEditing ? "Update Brand" : "Create Brand"}
              </button>
              <button onClick={resetForm} className="btn btn-secondary">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Brand List */}
      <div className="row mt-5">
        <div className="col-12">
          {/* Smaller Heading for Brand List */}
          <h2 className="mb-4 text-primary fs-6">Total Brands: {brands.length}</h2>
          <div className="card p-4 shadow-sm rounded-3">
            <table className="table table-bordered table-striped">
              <thead className="table-primary">
                <tr>
                  <th>Sr. No.</th>
                  <th>Brand Name</th>
                  <th>Brand Category</th>
                  <th>Brand Subcategory</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {brands.map((brand, index) => (
                  <tr key={brand.id} className="hover-table-row">
                    <td>{index + 1}</td>
                    <td>{brand.name}</td>
                    <td>{brand.category}</td>
                    <td>{brand.subCategory}</td>
                    <td>
                      <button
                        onClick={() => handleEditBrand(brand)}
                        className="btn btn-warning btn-sm me-2"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDeleteBrand(brand.id)}
                        className="btn btn-danger btn-sm"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandComponent;
